import { Capacitor } from '@capacitor/core'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { Share } from '@capacitor/share'

const EXPORT_DIR = 'exports'

export function sanitizeFilename(name) {
    return String(name || 'export').replace(/[\\/:*?"<>|]/g, '').trim() || 'export'
}

export async function saveWorkbook(XLSX, workbook, filename, dialogTitle = '') {
    const name = `${sanitizeFilename(filename)}.xlsx`

    if (Capacitor.getPlatform() === 'web') {
        XLSX.writeFile(workbook, name)
        return
    }

    const data = XLSX.write(workbook, { bookType: 'xlsx', type: 'base64' })

    const dirResult = await Filesystem.readdir({
        path: EXPORT_DIR,
        directory: Directory.Cache,
    }).catch(() => null)

    if (!dirResult) {
        await Filesystem.mkdir({
            path: EXPORT_DIR,
            directory: Directory.Cache,
            recursive: true,
        })
    }

    const savedFile = await Filesystem.writeFile({
        path: `${EXPORT_DIR}/${name}`,
        data,
        directory: Directory.Cache,
    })

    await Share.share({
        title: dialogTitle || name,
        files: [savedFile.uri],
        dialogTitle: dialogTitle || name,
    })
}
